/**
 * Universal Membership Roles
 *
 * Generic roles that work across different membership contexts:
 * - BusinessMembership (User → Business)
 * - TenantMembership (Admin → Tenant) - future
 * - CampaignMembership, etc. - future
 *
 * Follows traditional RBAC pattern: Owner > Admin > Editor > Viewer
 */
export var MembershipRole;
(function (MembershipRole) {
    /**
     * Full control - can delete entity, transfer ownership, manage everything
     */
    MembershipRole["OWNER"] = "OWNER";
    /**
     * Administrative access - manage members & settings, but cannot delete entity
     */
    MembershipRole["ADMIN"] = "ADMIN";
    /**
     * Editor access - create/modify content, cannot manage members or settings
     */
    MembershipRole["EDITOR"] = "EDITOR";
    /**
     * Read-only access - view data only
     */
    MembershipRole["VIEWER"] = "VIEWER";
})(MembershipRole || (MembershipRole = {}));
/**
 * Role hierarchy for permission checks
 * Higher index = more permissions
 */
export const MEMBERSHIP_ROLE_HIERARCHY = [
    MembershipRole.VIEWER,
    MembershipRole.EDITOR,
    MembershipRole.ADMIN,
    MembershipRole.OWNER,
];
/**
 * Check if a role has at least the required level
 *
 * @example
 * hasMinimumRole(MembershipRole.ADMIN, MembershipRole.EDITOR) // true
 * hasMinimumRole(MembershipRole.VIEWER, MembershipRole.ADMIN) // false
 */
export function hasMinimumRole(userRole, requiredRole) {
    const userLevel = MEMBERSHIP_ROLE_HIERARCHY.indexOf(userRole);
    const requiredLevel = MEMBERSHIP_ROLE_HIERARCHY.indexOf(requiredRole);
    return userLevel >= requiredLevel;
}
//# sourceMappingURL=membership-role.enum.js.map